'use client'

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable multiline-ternary */
/* eslint-disable @typescript-eslint/promise-function-async */

import React, { useEffect, useRef } from 'react'
import Image from 'next/image'
import assetLoader from '@utils/internalImageLoader'
import { getAdditionalWidgetProps } from '@configs/widgetModal.config'
import { useModalContext } from '@context/ModalContext/ModalContext'
import { getClassNames } from '@helpers/productWidgetHelper'
import { MODAL_CROSS_ICON } from '@constants/homepageLogos'
import {
  PRODUCT_WIDGETS_VS_BOTTOM_FLOATER_PROPS,
  PRODUCT_WIDGETS_VS_COMPONENTS,
  getCtaWidgetPurpleLayout,
} from '@configs/productWidget.config'
import styles from './WidgetModal.module.scss'

const WidgetModal = ({
  content,
  bottomFloaterWidgetCta,
  segmentEventCommonProperties,
  reqCookie,
  isSemPage,
  productWidgetData,
  regexPatternsData,
  isMobileDevice,
}) => {
  const { setShow, show } = useModalContext()
  const dropdownRef = useRef<HTMLDivElement>(null)

  const closeModal = event => {
    if (dropdownRef?.current !== null) {
      const isClickInside = dropdownRef?.current.contains(event.target)
      if (!isClickInside) {
        setShow(false)
      }
    } else {
      setShow(false)
    }
  }

  const renderWidget = () => {
    const Component = PRODUCT_WIDGETS_VS_COMPONENTS[bottomFloaterWidgetCta]
    const properties = {
      ...PRODUCT_WIDGETS_VS_BOTTOM_FLOATER_PROPS({ setShow })[bottomFloaterWidgetCta],
      isMobileDevice,
    }

    return (
      <Component
        {...properties}
        segmentEventCommonProperties={segmentEventCommonProperties}
        reqCookie={reqCookie}
        isSemPage={isSemPage}
        regexPatternsData={regexPatternsData}
        {...productWidgetData}
        {...getAdditionalWidgetProps(bottomFloaterWidgetCta)}
      />
    )
  }

  useEffect(() => {
    show ? (document.documentElement.style.overflowY = 'hidden') : (document.documentElement.style.overflowY = 'scroll')
  }, [show])

  const addWidthToWidgets = ['health-seo-widget']
  const inlineStyle = addWidthToWidgets.includes(bottomFloaterWidgetCta)
  const isCtaPurple = getCtaWidgetPurpleLayout[content?.widget]
  const modalContainerClassNames = getClassNames([styles.modal], {
    [styles.purpleBgModal]: isCtaPurple,
  })

  const crossIconSrc = isCtaPurple
    ? 'https://acko-cms.ackoassets.com/cross_icon_revamp_8d103004b5.svg'
    : `${assetLoader()}/images/crossIcon.svg`

  return show ? (
    <div
      className={styles.modalOverlay}
      onClick={event => {
        closeModal(event)
      }}>
      <div className={`${modalContainerClassNames} ${inlineStyle ? styles.isHealthWidget : ''}`} ref={dropdownRef}>
        <div className={styles.modalHeader}>
          <span
            className={styles.close}
            onClick={() => {
              setShow(false)
            }}>
            <Image
              src={bottomFloaterWidgetCta === 'challan-widget-landing-page' ? MODAL_CROSS_ICON : crossIconSrc}
              alt="Widget Cross Icon"
              width={18}
              height={18}
              loading="lazy"
            />
          </span>
        </div>
        <div className={styles.modalContent}> {show && renderWidget()} </div>
      </div>
    </div>
  ) : null
}

export default WidgetModal
